var e = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
function o(e2) {
  return e2 && e2.__esModule && Object.prototype.hasOwnProperty.call(e2, "default") ? e2.default : e2;
}
export {
  e as commonjsGlobal,
  o as getDefaultExportFromCjs
};
//# sourceMappingURL=_commonjsHelpers.js.map
